import { useUpdateUserIntegrationModal } from '@/features/update-user-integration'
import DeleteSvg from '@/shared/assets/images/Trash.svg'
import { useAppDispatch, useAppSelector } from '@/shared/lib/redux'
import { fetchUserIntegration, selectUserIntegration } from '../../model'

export const DeleteIntegration = () => {
    const { openDeleteUserIntegrationModal } = useUpdateUserIntegrationModal()
    const integration = useAppSelector(selectUserIntegration)
    const dispatch = useAppDispatch()

    const onDelete = () => {
        dispatch(fetchUserIntegration())
    }

    return (
        <button onClick={() => openDeleteUserIntegrationModal(integration, onDelete)}>
            <DeleteSvg width={20} height={20} />
        </button>
    )
}